import React, { useState } from 'react';
import Button from '../../elements/Button';
import { Card, Modal } from '@mantine/core';
import HistoryLog from '../../elements/HistoryLog';
import PropTypes from 'prop-types';

const HistoryBlock = ({
  historyBlock = [],
  onClick = () => {},
  isLoadingHistoryBlock = false
}) => {

  const [opened, setOpened] = useState(false);
  const mockHistory = historyBlock.length < 1 ? [
    {
      'actionType': 'block',
      'reason': 'NIK terblokir oleh sistem',
      'reasonDetail': 'NIK pelanggan yang didaftarkan tidak valid.',
      'isRequestUnblock': false
    },
  ] : historyBlock;
  const onClose = () => setOpened(false);
  const customBadgeText = {
    block: 'Diblokir',
    unblock: 'Disetujui'
  };
  return (
    <>
      <Button onClick={() => {
        onClick();
        setOpened(true);
      }} outlined>Riwayat Blokir</Button>
      <Modal centered onClose={onClose} opened={opened} size="lg" styles={{ title: {
        fontWeight: 600, fontSize: 30
      } }} title="Riwayat Pengajuan Buka Blokir Pelanggan">
        <Card px={0}>
          {!isLoadingHistoryBlock && <HistoryLog customBadgeText={customBadgeText}
            history={mockHistory} />}
        </Card>
        <Button fullWidth onClick={onClose}>Tutup</Button>
      </Modal>
    </>
  );
};

export default HistoryBlock;

HistoryBlock.propTypes = {
  historyBlock: PropTypes.array,
  isLoadingHistoryBlock: PropTypes.bool,
  onClick: PropTypes.func
};
